const Accordion = () => {
  const onHeaderClick = header => {
    const isExpanded = header.getAttribute("aria-expanded") === "true";
    const panel = document.getElementById(header.getAttribute("aria-controls"));

    header.setAttribute("aria-expanded", String(!isExpanded));
    panel.hidden = isExpanded;
  };

  const initAccordion = accordion => {
    const headers = accordion.querySelectorAll(".accordion__header");

    headers.forEach(header => {
      header.addEventListener("click", () => onHeaderClick(header));
    });
  };

  const init = () => {
    const accordions = document.querySelectorAll(".accordion");
    accordions.forEach(accordion => initAccordion(accordion));
  };

  return { init };
};

export default Accordion;
